import aipuruiInspectGroup from "./index.vue";
import aipuruiInspectGroupHome from "./Home.vue";

const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/aipuruiInspectGroupIndex",
    name: "aipuruiInspectGroupIndex",
    component: aipuruiInspectGroupHome
  },
  {
    path: "/aipuruiInspectGroup/login",
    name: "aipuruiInspectGroupLogin",
    component: login
  },
  {
    path: "/aipuruiInspectGroup",
    name: "aipuruiInspectGroup",
    redirect: "/aipuruiInspectGroup",
    component: aipuruiInspectGroup,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
    ]
  }
];
